import { normalizeLocationColor } from '@/lib/utils/locationColor';

interface LocationColorDotProps {
  colorCode: string | null | undefined;
}

export function LocationColorDot({ colorCode }: LocationColorDotProps) {
  return (
    <span
      className="h-2.5 w-2.5 rounded-full border border-black/20 shrink-0"
      style={{ backgroundColor: normalizeLocationColor(colorCode) }}
    />
  );
}
